/**
 * hover
 */
import { breakpoint, containerID } from '@/_modules/utils/variables';
import {TweenMax, Cubic} from 'gsap/all';

export default class hover {
  /**
   * コンストラクタ
   */
  constructor(el, index, isMobile) {
    // クラス名
    this.name = 'hover';
    this.el = el;
    this.index = index;
    this.isMobile = isMobile;
    this.hover = null;
    this.wrap1 = null;
    this.wrap2 = null;
    this.moveTimer = null;
    this.counter = 0;
    this.init();
  }

  /**
   * 初期
   */
  init() {
    //this.hovers = document.querySelectorAll('.c-hover');
    this.el.addEventListener('mouseenter', this.onHover.bind(this));
    this.el.addEventListener('mouseleave', this.onHover.bind(this));
    //this.el.addEventListener('mousemove', this.onHover.bind(this));

    this.hover = this.el.querySelector('.js-hover');
    this.wrap1 = this.el.querySelector('.js-transform');
    this.wrap2 = this.el.querySelector('.js-transform__wrap');
    //TweenMax.set(this.hover, {perspective: '800px', rotation: 0});
    if (!this.isMobile) {
      // video
      this.video = this.wrap2.querySelector('.js-video');
      if (this.video) {
        this.video.src = this.video.getAttribute('data-src');
        this.video.muted = true;
        this.video.loop = true;
        this.video.playsinline = true;
        this.video.addEventListener('ended', function() {
          this.video.play();
        });
      }
    }
  }

  onHover(e)
  {
    if (e.type === 'mouseenter'|| e.type === 'touchstart') {
      this.over(e);
    } else if (e.type === 'mouseleave'|| e.type === 'touchend'|| e.type === 'touchcancel') {
      this.out(e);
    }else if (e.type === 'mousemove'|| e.type === 'touchmove') {
      //this.mousemove(e);
    }
  }

  over(e) {
    TweenMax.killTweensOf([this.wrap1, this.wrap2]);

    //重なりを調整
    /*TweenMax.set(e.currentTarget.parentNode.parentNode,{
      "z-index":this.depth++
    });*/

    this.target = e.currentTarget;

    const event = {
      clientX: e.clientX,
      clientY: e.clientY,
      targetTouches: e.targetTouches
    };

    if (this.video) {
      TweenMax.fromTo(this.video, 0.5,{visibility: 'visible'}, {opacity: 1});
      this.video.play(0);
    }

    this.update(event);
  }

  out(e) {
    cancelAnimationFrame(this.moveTimer);
    this.tick = false;

    TweenMax.killTweensOf([this.wrap1, this.wrap2]);

    //元の位置に戻す
    TweenMax.to(this.wrap1, 0.5, {
      x: 0,
      y: 0,
      z: 0,
      skewX: 0,
      skewY: 0,
      scale: 1,
      rotationX: 0,
      rotationY: 0,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.wrap2, 0.5, {
      x: 0,
      y: 0,
      z: 0,
      skewX: 0,
      skewY: 0,
      scale: 1,
      rotationX: 0,
      rotationY: 0,
      ease: Cubic.easeOut
    });

    if (this.video) {
      TweenMax.to(this.video, {opacity: 0});
      this.video.pause();
    }
  }
/*
  mousemove(e) {
    if (!this.tick) {
      this.tick = true;
      this.target = e.currentTarget;

      const event = {
        clientX: e.clientX,
        clientY: e.clientY,
        targetTouches: e.targetTouches
      };

      this.moveTimer = requestAnimationFrame(this.update.bind(this, event));
    }
  }
*/

  update(e) {
    const rect = this.target.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //マウス座標を取得する
    let mX = e.clientX || e.targetTouches[0].pageX;
    let mY = e.clientY || (e.targetTouches[0].pageY - scrollTop);

    //DOM座標を取得する
    //let boxX = rect.left;
    //let boxY = rect.top;

    //DOM上のマウス座標を求める
    //let px = Math.round(mX - boxX);
    //let py = Math.round(mY - boxY);

    //DOMのセンター座標を求める
    let boxWidth = rect.width;
    let boxHeight = rect.height;

    let px = this.randomArr([0, boxWidth]);
    let py = this.randomArr([0, boxHeight]);

    let cx = Math.round(boxWidth * 0.5);
    let cy = Math.round(boxHeight * 0.5);

    //DOMのセンターからの距離を求める（＋調整）
    let tx = (px - cx) / 8;
    let ty = (py - cy) / 8;


    const rx = tx * Math.random() * 0.8;
    const ry = ty * Math.random() * 0.8;

    let skew = (tx * ty) * 0.04;

    if (skew > 15 || skew < -15 ) {
      skew = Math.sign(skew) * 15;
    }

    this.counter = this.counter + 0.1;
    //console.log(Math.PI / this.counter);
    //console.log(Math.sin(this.counter) * 0.001);

    TweenMax.killTweensOf([this.wrap1, this.wrap2]);

    //DOM移動アニメーション（x,yで移動方向、rotationの+-で傾斜方向を調整）
    TweenMax.to(this.wrap1, 0.5, {
      z: -220,
      skewX: skew,
      skewY: skew / 4,
      rotationX: rx,
      rotationY: ry,
      ease: Cubic.easeOut
    });

    TweenMax.to(this.wrap2, 0.5, {
      //x: tx / 16,
      //y: ty / 16,
      skewX: -skew,
      skewY: -skew / 4,
      scale: 1.2,
      rotationX: -rx / 2,
      rotationY: -ry / 2,
      ease: Cubic.easeOut
    });

    this.tick = false
  }

  // ----------------------------------------
  // minからmaxまでランダム int
  // ----------------------------------------
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // ----------------------------------------
  // 配列の中ランダム
  // ----------------------------------------
  randomArr(arr) {
    return arr[this.randomInt(0, arr.length - 1)]
  }
}